<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import LaisCard from 'dashboard/components-next/LaisCard.vue';
import SalesDetailFactList from './SalesDetailFactList.vue';

const props = defineProps({
  party: { type: Object, required: true },
  cardTitle: { type: String, default: '' },
});
const { t } = useI18n();
const address = computed(() => props.party.profile?.address || {});
const title = computed(
  () => props.cardTitle || t('SALES_PARTIES.ADDRESS.TITLE')
);
const items = computed(() => [
  { key: 'cep', label: t('SALES_PARTIES.FORM.CEP'), value: address.value.cep },
  {
    key: 'street',
    label: t('SALES_PARTIES.FORM.STREET'),
    value: address.value.street,
  },
  {
    key: 'number',
    label: t('SALES_PARTIES.FORM.NUMBER'),
    value: address.value.number,
  },
  {
    key: 'unit',
    label: t('SALES_PARTIES.FORM.UNIT'),
    value: address.value.unit,
  },
  {
    key: 'complement',
    label: t('SALES_PARTIES.FORM.COMPLEMENT'),
    value: address.value.complement,
  },
  {
    key: 'city',
    label: t('SALES_PARTIES.FORM.CITY'),
    value: address.value.city,
  },
  {
    key: 'state',
    label: t('SALES_PARTIES.FORM.STATE'),
    value: address.value.state,
  },
  {
    key: 'neighborhood',
    label: t('SALES_PARTIES.FORM.NEIGHBORHOOD'),
    value: address.value.neighborhood,
  },
]);
</script>

<template>
  <LaisCard :title="title" prefix-icon="i-lucide-map-pin">
    <SalesDetailFactList :items="items" />
  </LaisCard>
</template>
